import {
  Sheet,
  SheetContent,
  SheetBody,
  SheetHeader,
  SheetTitle,
} from "@repo/ui/components/Base/Sheet";
import { Spinner } from "@repo/ui/components/Base/Spinner";
import { AgendaModuleForm } from "./AgendaModuleForm";
import { useGetAgendaModule } from "@/hooks/queryHooks/agendaModuleHooks";

interface EditAgendaModuleSheetProps {
  open: boolean;
  setOpen: (arg1: boolean) => void;
  tenantId: string;
  agendaModuleId: string;
}
export const EditAgendaModuleSheet = ({
  open,
  setOpen,
  tenantId,
  agendaModuleId,
}: EditAgendaModuleSheetProps) => {
  const { data: agendaModule } = useGetAgendaModule(tenantId, agendaModuleId);
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent className="overflow-y-scroll">
        <SheetHeader>
          {!agendaModule && <Spinner />}
          {agendaModule && (
            <div>
              <SheetTitle>{`Edit ${agendaModule.name}`}</SheetTitle>
              <SheetBody>
                <AgendaModuleForm
                  isTemplate={agendaModule.template ?? false}
                  agendaModuleFormData={agendaModule}
                  tenantId={tenantId}
                  handleCancel={() => setOpen(false)}
                  handleComplete={() => setOpen(false)}
                />
              </SheetBody>
            </div>
          )}
        </SheetHeader>
      </SheetContent>
    </Sheet>
  );
};
